import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FeedbackComponent } from '../../../core/feedback/feedback/feedback.component';
import { NgbNav, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase, NgbNavContent, NgbNavOutlet } from '@ng-bootstrap/ng-bootstrap/nav';
import { ProfileComponent } from '../profile/profile.component';
import { BillingComponent } from '../billing/billing.component';

@Component({
    selector: 'app-profile-container',
    templateUrl: './profile-container.component.html',
    styleUrls: ['./profile-container.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FeedbackComponent, NgbNav, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase, NgbNavContent, ProfileComponent, BillingComponent, NgbNavOutlet]
})
export class ProfileContainerComponent implements OnInit {
  constructor() { }

  ngOnInit() {
  }
}
